var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: " text-base font-medium rounded border transition-all flex gap-2 items-center justify-center whitespace-nowrap",
    class: [_vm.buttonSize, _vm.buttonType, {
      disabled: _vm.disabled
    }],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm.icon ? _c(_vm.icon, {
    tag: "component"
  }) : _vm._e(), _vm.isLoading ? _c('span', {
    staticClass: "flex items-center gap-2"
  }, [_c('svg', {
    staticClass: "animate-spin h-4 w-4 text-white",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "4"
    }
  }), _c('path', {
    staticClass: "opacity-75",
    attrs: {
      "fill": "currentColor",
      "d": "M4 12a8 8 0 018-8v8H4z"
    }
  })]), _vm._v(" " + _vm._s(_vm.buttonText) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }